



















import { Component, Prop, Vue } from "vue-property-decorator";
import Quantity from "@/components/common/Quantity.vue";

@Component({ components: { Quantity } })
export default class ActionQuantity extends Vue {
  @Prop({ type: String, default: "table" })
  readonly type!: string;

  @Prop({ type: String, default: "catalog" })
  readonly context!: string;

  @Prop({ type: Number, default: 1 })
  readonly quantity!: number;

  @Prop({ type: Number, default: 999 })
  readonly max!: number;

  @Prop({ type: Boolean, default: false })
  readonly isInCart!: boolean;

  @Prop({ type: [String, Boolean], default: "" })
  readonly isOnSale!: boolean | string;

  @Prop({ type: Function, default: () => null })
  readonly changeHandler!: (quantity: number) => void;

  @Prop({ type: Function, default: () => null })
  readonly addToCart!: () => void;

  @Prop({ type: Function, default: () => null })
  readonly removeFromCart!: () => void;

  @Prop({ type: Array, default: () => [] })
  readonly tooltipBreakpoints!: Array<{ value: number; message: string }>;

  get tooltipText(): any {
    for (let i = 0; i < this.tooltipBreakpoints.length; i++) {
      const bp = this.tooltipBreakpoints[i];
      if (this.quantity >= bp.value) {
        return bp.message;
        break;
      }
    }
    return "";
  }
}
